import React from 'react';
import EventTracking from 'lib/EventTracking';
import Container from 'components/Container';
import Row from 'components/Row';
import Text from 'components/Text';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingHeading from 'coaching/components/CoachingHeading';
import CoachingHelpForm from 'coaching/components/CoachingHelpFormView/CoachingHelpForm';
import {
  GetCoachingHelpForm_me,
  GetCoachingHelpForm_coaching_coachingHomeDashboard_participants,
} from 'coaching/queries/__generated__/GetCoachingHelpForm';

type Props = {
  requester: GetCoachingHelpForm_me | null;
  students?: GetCoachingHelpForm_coaching_coachingHomeDashboard_participants[];
  eventPrefix: string;
  onSubmitSuccess: (email: string) => void;
};

export default function CoachingHelp(props: Props) {
  React.useEffect(() => {
    EventTracking.trackKey(`${props.eventPrefix}.form.view`);
  }, [props.eventPrefix]);

  return (
    <Container size="medium" align="left">
      <CoachingHelpIntro />
      <CoachingHelpForm {...props} />
    </Container>
  );
}

function CoachingHelpIntro() {
  return (
    <React.Fragment>
      <CoachingHeading>We’re here to help.</CoachingHeading>
      <Row>
        <Text size="medium" color="graphite">
          {`${CoachingConstants.COACHING_HELP_HOURS} We’ll just need a few more details from you.`}
        </Text>
      </Row>
    </React.Fragment>
  );
}
